<script>
	export let on_autofill_fetched = () => {};

	let elementUploadRef;
	let file = null;
	let dragging = false;
	let error_upload = "";

	const ALLOWED_FILES_STR = "PDF or DOCX";
	const ALLOWED_MAX_SIZE_MB = "5";

	function handleDrop(event) {
		event.preventDefault();
		dragging = false;
		const droppedFile = event.dataTransfer.files[0];
		if (isValidFile(droppedFile)) {
			file = droppedFile;
		} else {
			alert("Only PDF and DOCX files are allowed.");
		}
	}

	function isValidFile(file) {
		const maxSize = ALLOWED_MAX_SIZE_MB * 1024 * 1024; // 5 MB in bytes
		const validTypes = ["application/pdf"];
		const validExtensions = [".docx"];

		if (!file) return false;

		// The input alreay filters the file types
		const isValidType = validTypes.includes(file.type);
		const isValidExtension = validExtensions.some(ext => file.name.endsWith(ext));
		const isValidSize = file.size <= maxSize;

		return (isValidType || isValidExtension) && isValidSize;
	}

	function handleUpload(e) {
		error_upload = "";

		// Single file selection is set on the input
		const file = e.target.files[0];

		if (!file) return;

		if (!isValidFile(file)) {
			error_upload = `Only ${ALLOWED_FILES_STR} files up to ${ALLOWED_MAX_SIZE_MB}MB are allowed.`;
			return;
		}

		const formData = new FormData();
		formData.append("action", "get_file_profile_scan");
		formData.append("file", file);

		app.body_spinner.add_to(document.body);

		fetch(`${app.lucep_ai.host}/api/`, {
			method: "POST",
			body: formData,
			headers: app.lucep_ai.get_auth_header(),
			credentials: 'include'
		})
		.then((res) => {
			if (!res.ok) {
				error_upload = "An error occurred while uploading the file. Please, verify your connection and try again.";
				return;
			}
			return res.json();
		})
		.then(res => {
			elementUploadRef.value = "";
			if (res.status != "ok" || !res.profile) {
				app.toast_msg.show("This file couldn't be scanned by our AI Agent.");
				return;
			}

			app.body_spinner.remove();
			on_autofill_fetched(res.profile);
		})
		.catch((err) => {
			console.error(err);
			elementUploadRef.value = "";
			app.body_spinner.remove();
			error_upload = "An error occurred while uploading the file. Please, verify the file content and try again.";
		});
	}
</script>


<label for="page_url" class="form-label" style="line-height: 1.85rem;">
	Enter a file that <span class="highlight_text">describe the project's product or service</span>.<br>
	Our <b>Profile Scanner AI Agent</b> will import the suggest settings:
</label>

<div class="drop-zone-container">
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<div
		class="drop-zone {dragging ? 'dragging' : ''}"
		on:dragover|preventDefault={() => (dragging = true)}
		on:dragleave={() => (dragging = false)}
		on:drop={handleDrop}
		on:click={() => elementUploadRef?.click()}
	>
		{#if file}
			<p>Selected file: <strong>{file.name}</strong></p>
		{:else}
			<div class="mb-3">
				<svg width="100px" height="100px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
					<path d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div>
			<div>
				<b>Choose a file</b> or drag it here.
			</div>
		{/if}
		<div class="upload-requirements">
			<div>File type: <b>{ALLOWED_FILES_STR}</b></div>
			<div>Max size: <b>{ALLOWED_MAX_SIZE_MB}MB</b></div>
		</div>
	</div>
</div>
<div class="mt-2">
	<ul class="upload-restrictions">
		<li>The file shouldn't be in secure format or protected by a password.</li>
		<li>The file should contains text content, currently ORC is disabled.</li>
	</ul>
</div>

{#if error_upload}
	<span class="error_upload">{error_upload}</span>
{/if}

<input
	type="file"
	accept=".pdf,.docx"
	bind:this={elementUploadRef}
	on:change={handleUpload}
	style="margin-top: 1rem;"
/>

<style>
	.highlight_text {
		background-color: #ede1d3;
	}
	.upload-restrictions {
		color: gray;
		font-size: 0.8rem;
	}
	.upload-requirements {
		position: absolute;
		top: .5rem;
		right: .5rem;
		opacity: 0.75;
		font-size: 0.8rem;
		padding: .75rem;
		text-align: right;
		font-weight: bold;
		color: gray;
	}
	.upload-requirements b {
		color:black;
	}
	input[type="file"] {
		display: none;
	}
	@keyframes bounce {
		0%, 100% { transform: translateY(0) scale(1); }
		50% { transform: translateY(-5px) scale(1.05); }
	}
	.drop-zone-container {
		position: relative;
		background-color: #f3f3f3;
		padding: 0.5rem;
	}
	.drop-zone-container:hover {
		background-color: #e4e4e4;
	}
	.drop-zone-container:hover svg {
		animation: bounce 1s infinite ease-in-out;
	}
	.drop-zone {
		cursor: pointer;
		border: 2px dashed #ccc;
		padding: 2rem;
		text-align: center;
		border-radius: 8px;
		transition:
			border-color 0.2s,
			background 0.2s;
	}

	.drop-zone.dragging {
		border-color: #007bff;
		background-color: #eef6ff;
	}

	.error_upload {
		color: red;
		font-size: 0.8rem;
		margin-top: 0.5rem;
	}
</style>